import { booleanMapping, colorMapping, genderMapping } from '../types/ahcr-event.types'

export const getGenderInfo = (gender: string | null) => {
  const genderLower = gender?.toLowerCase() || 'unknown'
  const label = genderMapping[genderLower as keyof typeof genderMapping] || 'Desconhecido'
  const severity: 'info' | 'warning' | 'success' | 'danger' | null =
    genderLower === 'male' ? 'info' : genderLower === 'female' ? 'warning' : null
  const icon = genderLower === 'male' || genderLower === 'female' ? 'pi-user' : 'pi-question'
  return { label, severity, icon }
}

export const getColorInfo = (color: string | null) => {
  const colorLower = color?.toLowerCase() || 'unknown'
  return colorMapping[colorLower as keyof typeof colorMapping] || 'Desconhecido'
}

export const getHatInfo = (hat: any) => {
  const hatStr = hat?.toString().toLowerCase() || 'unknown'
  const label = booleanMapping[hatStr as keyof typeof booleanMapping] || 'Desconhecido'
  const colorClass =
    hatStr === 'true' || hatStr === 'yes' ? 'green' : hatStr === 'false' || hatStr === 'no' ? 'red' : 'blue'
  return { label, colorClass }
}
